// src/components/OrgResolutionError.jsx
// Shown by AuthHandler when OrganizationContext fails to resolve the user's org
// after bounded retries. Never an infinite loader: the user can retry (re-runs the
// resolution) or sign out. Hardcoded Spanish, consistent with ConsentGate (see the
// i18n debt tracked as P2-14 in LANZAMIENTO-ESTADO.md).
import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

export default function OrgResolutionError({ onRetry }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <h2 style={styles.title}>No pudimos cargar tu cuenta</h2>
        <p style={styles.text}>
          Hubo un problema al cargar tu organización. Revisa tu conexión e inténtalo
          de nuevo.
        </p>
        <button type="button" onClick={onRetry} style={styles.button}>
          Reintentar
        </button>
        <button type="button" onClick={() => signOut(auth)} style={styles.signout}>
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.5rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    width: '100%',
    maxWidth: 440,
    background: '#fff',
    borderRadius: 14,
    padding: '32px 28px',
    boxShadow: '0 10px 40px rgba(0,0,0,.18)',
    boxSizing: 'border-box',
    textAlign: 'center',
  },
  title: { margin: '0 0 12px', color: '#111827', fontSize: 22, fontWeight: 700 },
  text: { margin: '0 0 24px', color: '#4B5563', fontSize: 15, lineHeight: 1.6 },
  button: {
    width: '100%', padding: '12px', color: '#fff', border: 'none', borderRadius: 8,
    fontSize: 16, fontWeight: 600, background: '#667eea', cursor: 'pointer',
  },
  signout: {
    width: '100%', marginTop: 10, padding: '8px', background: 'transparent',
    color: '#6b7280', border: 'none', fontSize: 13, cursor: 'pointer', textDecoration: 'underline',
  },
};
